import { InsightsState } from 'app-redux/InsightsState';
import diseaseActivitiesGlobalSelectors from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';
import DiseaseGlobalCard from './DiseaseGlobalCard';

const GlobalDiseasesList: React.FC = () => {
  const diseaseIds: number[] = useSelector<InsightsState, number[]>(
    diseaseActivitiesGlobalSelectors.getFilteredDiseaseIds
  );
  return (
    <List>
      {diseaseIds.map(diseaseId => (
        <DiseaseGlobalCard diseaseId={diseaseId} key={diseaseId} />
      ))}
    </List>
  );
};
export default GlobalDiseasesList;
